module.exports = __webpack_public_path__ + "img/img4.b66cf023.svg";